import React from 'react';
import './Hero.scss';
import CustomBtn from '../../../../components/CustomBtn/CustomBtn';
import { useMediaQuery } from 'react-responsive';
import { isExternalLink, safeHtml } from '../../../../services/helpers';

const Hero = ({ strapiData }) => {

    const isSmallMobile = useMediaQuery({ maxWidth: 480 }); // Breakpoint pour SM
    return (
        <section className="hero">
            <div className="hero__content">
                {
                    isSmallMobile ?
                        <div className="hero__text script-text" dangerouslySetInnerHTML={safeHtml(strapiData.TexteMobile)} />

                        :
                        <div className="hero__text script-text" dangerouslySetInnerHTML={safeHtml(strapiData.Texte)} />
                }
                <CustomBtn
                    type={isExternalLink(strapiData.Bouton.LienBouton) ? 'external' : 'internal'}
                    title={strapiData.Bouton.TexteBouton}
                    link={
                        strapiData.Bouton.LienBouton === null ?
                            ''
                        :
                            (isExternalLink(strapiData.Bouton.LienBouton) ?
                                strapiData.Bouton.LienBouton
                            :
                                '/' + strapiData.Bouton.LienBouton)
                    }
                    bkg_color={'transparent'}
                    bkg_color_hover={'#EEE6DB'}
                    text_color={'#EEE6DB'}
                    text_color_hover={'#361215'}
                    border_color={'#EEE6DB'}
                    border_color_hover={'#EEE6DB'}
                    font_family={"Great Vibes"}
                    font_size={'30px'}
                    font_weight={'normal'}
                    border_radius={'3px'}
                    width={'430px'}
                    height={'55px'}
                    margin={'10px 0'}
                    letter_spacing={'2px'}
                />
            </div>
        </section>
    );
};

export default Hero;